import './style.scss';
import Button from 'components/atoms/Button';
import CognyAPI from 'components/_classes/CognyAPI';
import SubmitStatus from 'components/molecules/SubmitStatus';
import { useRouteMatch } from 'react-router-dom';
import React, { useState } from 'react';
import Form from 'components/atoms/Form';
import { useCookies } from 'react-cookie';
import ReactGA from "react-ga4";

const SubmitButton = (props) => {
  const { isLoaded, error } = props;
  return (
    <>
      <Button type="submit" className="mmm-get-started">Get started with Media mix modelling</Button>
      <SubmitStatus isLoaded={isLoaded} error={error} parentClass="TaskEditor" successMessage="" />
    </>
  )
}

function MMMForm(props) {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(true);
  const [cookies] = useCookies(["token", "project"]);
  const [message, setMessage] = useState("");
  const match = useRouteMatch();
  const [warehouseId] = useState(match.params.warehouse_id);

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLoaded(false);

    const newFeature = {
      feature: "mmm",
    };

    console.log("in submit");

    if (cookies.token) {
      const api = new CognyAPI(cookies.token);
      ReactGA.event({
        category: "UserActions",
        action: "AddFeatureMMM",
        label: cookies.token,
      });
      api.addWarehouseFeature(warehouseId, newFeature)
        .then(
          (taskResult) => {
            setIsLoaded(true);
            setMessage("You have been added to the Media Mix Modelling waitlist, we'll be in touch!");
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )
    }
  }

  return (
    <>
      <div className="TaskList">
        <div className="TaskList__welcome">
          <h1 className="TaskList__title">Media mix modelling <span className="TaskList__logo">(beta)</span></h1>
        </div>

        <img src="/images/mmm_sample.png" width="300" align="right" style={{ padding: 20 + 'px' }} alt="Media Mix Modelling result" />
        <p>Media mix modelling (MMM) is a methodology to figure out what effect your different advertising efforts have using statitical models and your ad campaign and sales statistics as input.</p>
        <p>A good MMM-model will tell you how to allocate your budget, what to expect in the coming months and which of your ad campaigns are delivering.</p>
        <div>
          <br />
          <br />
          <br />
          <br />
          <br />
          {message === "" ?
            <Form className="TaskEditor__form" onSubmit={handleSubmit}>
              <SubmitButton isLoaded={isLoaded} error={error} />
            </Form>
            : <p>{message}</p>}
        </div>
      </div>
    </>
  );
}

export default MMMForm;
